import React, { useState, useEffect } from 'react';

import Header from '../elements/Header';

import LeftSidebar from 'crm/elements/Sidebar/LeftSidebar';

const MOBILE_WIDTH = 768;
const LEFT_NAVBAR_HIDDEN = 'crm-left-navbar-hidden';

type Props = Readonly<{ pageName: string; children: React.ReactNode }>;

function MainLayout({ pageName, children }: Props) {
    const [mobileLayout, setMobileLayout] = useState<boolean>(window.innerWidth < MOBILE_WIDTH);
    const [topLogoVisible, setTopLogoVisible] = useState<boolean>(false);
    const [mobileNavbarVisible, setMobileNavbarVisible] = useState<boolean>(false);
    const [leftNavbarHidden, setLeftNavbarHidden] = useState<boolean>(
        sessionStorage.getItem(LEFT_NAVBAR_HIDDEN) === String(true)
    );

    const toggleLeftNavbar = () => {
        const newLeftNavbarHidden = !leftNavbarHidden;
        sessionStorage.setItem(LEFT_NAVBAR_HIDDEN, String(newLeftNavbarHidden));
        setLeftNavbarHidden(newLeftNavbarHidden);
    };

    const toggleMobileNavbar = () => setMobileNavbarVisible((prev) => !prev);

    useEffect(() => {
        function handleResize() {
            setMobileLayout(window.innerWidth < MOBILE_WIDTH);
        }
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div
            id="main-wrapper"
            data-theme="light"
            data-layout="vertical"
            data-navbarbg="skin6"
            data-sidebartype={leftNavbarHidden || mobileLayout ? 'mini-sidebar' : 'full'}
            data-sidebar-position="fixed"
            data-header-position="fixed"
            data-boxed-layout="full"
            className={mobileNavbarVisible && mobileLayout ? 'show-sidebar' : ''}
        >
            <Header
                topLogoVisible={topLogoVisible}
                leftNavbarHidden={leftNavbarHidden}
                mobileNavbarVisible={mobileNavbarVisible}
                toggleLeftNavbar={toggleLeftNavbar}
                toggleMobileNavbar={toggleMobileNavbar}
            />
            <LeftSidebar setTopLogoVisible={setTopLogoVisible} />
            <div className="page-wrapper">
                <div className="page-breadcrumb">
                    <div className="row">
                        <div className="col-12 align-self-center">
                            <h4 className="page-title">{pageName}</h4>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">{children}</div>
            </div>
        </div>
    );
}

export default MainLayout;
